// Ob'ekt brendi (`venue.portal_template`) — SOF mantiq, hech qanday
// bog'liqliksiz (`zod`, `axios`, `@/` taxallusi yo'q).
//
// ⚠️ Nega alohida fayl: bu funksiyalar avval `api.ts` ichida yashirin
// (eksport qilinmagan) turardi va `api.ts` `axios` bilan `import.meta.env`
// ga bog'langan — ya'ni uni Node'dan import qilib bo'lmasdi. Natijada
// `tests/portal-logic.mjs` mantiqning NUSXASI ustida ishlardi va manba
// o'zgarganini sezmasdi: qorovulni manbadan olib tashlaganda ham test
// yashil qolardi. Sof qismni ajratish testga HAQIQIY manbani import
// qilish imkonini beradi — nusxa yo'q, sirg'alish (drift) yo'q.
//
// `api.ts` bu yerdagilarni qayta eksport qiladi, shuning uchun mavjud
// import joylari o'zgarmadi.

export interface PortalBranding {
  logoUrl: string | null
  primaryColor: string | null
  /** Joriy tilga mos salomlashish; til uchun matn yo'q bo'lsa `null` */
  welcome: { uz: string | null; ru: string | null; en: string | null }
  termsUrl: string | null
  supportPhone: string | null
}

/**
 * Backenddan kelgan xom shablon. Shakl `api.ts` dagi `portalTemplateSchema`
 * bilan bir xil, lekin STRUKTURAVIY yozilgan — shu fayl `zod` ga bog'lanib
 * qolmasligi uchun (yuqoridagi izohga qarang). Sxema o'zgarsa `api.ts` dagi
 * `toBranding(parsed.template)` chaqiruvi tip xatosi beradi.
 */
export interface PortalTemplateRaw {
  logoUrl?: string | null
  primaryColor?: string | null
  welcomeUz?: string | null
  welcomeRu?: string | null
  welcomeEn?: string | null
  termsUrl?: string | null
  supportPhone?: string | null
}

/** `#rgb` yoki `#rrggbb` — boshqasi antd tokeniga umuman bermaydi */
const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i

/**
 * Havolani FAQAT `https://` bo'lsa qabul qiladi.
 *
 * ⚠️ Bu paranoyya emas: portal ISHONCHSIZ zonada ishlaydi
 * (`shared/api/client.ts`) va bu qiymatlar panelda odam tomonidan
 * kiritiladi. `javascript:` yoki `data:` sxemasi `<a href>` ga tushsa
 * bu mehmon brauzerida bajariladigan kod bo'lardi. Backend ham
 * `https` ni talab qiladi (`PortalTemplate` javadoc'i) — bu ikkinchi
 * qatlam, birinchisining o'rniga emas.
 */
export function safeHttpsUrl(value: string | null | undefined): string | null {
  if (!value) return null
  const trimmed = value.trim()
  return /^https:\/\/[^\s]+$/i.test(trimmed) ? trimmed : null
}

export function toBranding(raw: PortalTemplateRaw | null | undefined): PortalBranding | null {
  if (!raw) return null
  const branding: PortalBranding = {
    logoUrl: safeHttpsUrl(raw.logoUrl),
    // Noto'g'ri shaklda kelgan rang JIMGINA tashlanadi: antd tokeni uni
    // tahlil qila olmasa butun palitrani buzardi va mehmon oq ekran
    // ko'rardi — sozlash xatosi mehmonning internetiga to'sqinlik
    // qilmasligi kerak.
    primaryColor: raw.primaryColor && HEX_COLOR.test(raw.primaryColor.trim())
      ? raw.primaryColor.trim()
      : null,
    welcome: {
      uz: raw.welcomeUz?.trim() || null,
      ru: raw.welcomeRu?.trim() || null,
      en: raw.welcomeEn?.trim() || null,
    },
    termsUrl: safeHttpsUrl(raw.termsUrl),
    supportPhone: raw.supportPhone?.trim() || null,
  }
  const empty =
    !branding.logoUrl &&
    !branding.primaryColor &&
    !branding.termsUrl &&
    !branding.supportPhone &&
    !branding.welcome.uz &&
    !branding.welcome.ru &&
    !branding.welcome.en
  // Bo'sh shablon `null` bilan bir xil — chaqiruvchi ikki holatni
  // ajratishga majbur bo'lmasin.
  return empty ? null : branding
}

/** Joriy tilga mos salomlashish; shu til uchun matn yo'q bo'lsa `null`. */
export function welcomeText(branding: PortalBranding | null, language: string): string | null {
  if (!branding) return null
  const key = language.slice(0, 2).toLowerCase()
  // ⚠️ ZAXIRA TILGA O'TILMAYDI. Ob'ekt faqat ruscha matn yozgan bo'lsa,
  // uni ingliz tilida ochgan mehmonga KO'RSATMASLIK to'g'ri: salomlashish
  // ixtiyoriy bezak va tushunilmaydigan tildagi matn ko'rsatishdan ko'ra
  // umuman ko'rsatmaslik yaxshiroq.
  if (key === 'uz') return branding.welcome.uz
  if (key === 'ru') return branding.welcome.ru
  if (key === 'en') return branding.welcome.en
  return null
}
